import React from 'react'

import { IconInspiringSmall } from '@s4l/icons/IconInspiringSmall'
import { IconInspiringLarge } from '@s4l/icons/IconInspiringLarge'

import { BreakpointSizes } from 'src/types/device'
import { useDevice } from 'src/hooks/useDevice'

interface ILogoBrand {
  isResponsive?: boolean
}

const LogoInspiring = ({ isResponsive = false }: ILogoBrand) => {
  const { activeBreakpoint } = useDevice()
  if (isResponsive && activeBreakpoint < BreakpointSizes.M) {
    return <IconInspiringSmall data-testid="logo-inspiring-mobile" />
  }

  return <IconInspiringLarge data-testid="logo-inspiring-wide" />
}

export default LogoInspiring
